import React, { type JSX } from 'react';
import { FormProvider, useForm } from 'react-hook-form';

export interface FormWrapperProps {
  children: JSX.Element;
  preSelected?: string[];
  onSubmit: (data: DeviceSelection, e?: React.BaseSyntheticEvent) => void;
  preRemovedDiscontinuedDevices: string[];
}

export interface DeviceSelection {
  selectedProductCodes: string[];
  removedDiscontinuedDevices: string[];
}

export const CatalogProductSelectionFormWrapper = ({
  children,
  preSelected,
  onSubmit,
  preRemovedDiscontinuedDevices,
}: FormWrapperProps) => {
  const methods = useForm({
    mode: 'all',
    shouldFocusError: true,
    defaultValues: {
      selectedProductCodes: preSelected,
      removedDiscontinuedDevices: preRemovedDiscontinuedDevices,
    },
  });

  return (
    <FormProvider {...methods}>
      <form onSubmit={methods.handleSubmit(onSubmit)} noValidate>
        {children}
      </form>
    </FormProvider>
  );
};
